/**
 * The English source catalog — bundled EAGERLY, because it is the fallback for every other
 * locale and the game must be able to start with no other catalog reachable (REQ-10, NFR).
 *
 * `MessageKey` is derived from these files, so a `t("…")` call naming a key English does not
 * have is a TYPE error, not a blank button in production.
 */
import account from "@shared/i18n/locales/en/account.json";
import battles from "@shared/i18n/locales/en/battles.json";
import care from "@shared/i18n/locales/en/care.json";
import common from "@shared/i18n/locales/en/common.json";
import errors from "@shared/i18n/locales/en/errors.json";
import gamedata from "@shared/i18n/locales/en/gamedata.json";
import home from "@shared/i18n/locales/en/home.json";
import evolution from "@shared/i18n/locales/en/evolution.json";
import navigation from "@shared/i18n/locales/en/navigation.json";
import notifications from "@shared/i18n/locales/en/notifications.json";
import progression from "@shared/i18n/locales/en/progression.json";
import story from "@shared/i18n/locales/en/story.json";
import type { I18nNamespace } from "@shared/i18n/localeConfig";

/** A flat catalog: stable key → ICU MessageFormat string. */
export type Catalog = Readonly<Record<string, string>>;

const EN_NAMESPACES = {
  common,
  navigation,
  care,
  battles,
  evolution,
  progression,
  notifications,
  errors,
  account,
  gamedata,
  home,
  story,
} as const satisfies Record<I18nNamespace, Catalog>;

type NamespaceKeys<T> = T extends Record<infer K, string> ? K : never;

/** Every key the English source defines. */
export type MessageKey = {
  [N in keyof typeof EN_NAMESPACES]: NamespaceKeys<(typeof EN_NAMESPACES)[N]>;
}[keyof typeof EN_NAMESPACES] &
  string;

export const EN_CATALOG: Catalog = Object.freeze(Object.assign({}, ...Object.values(EN_NAMESPACES)));
